// removed by extract-text-webpack-plugin
module.exports = {"cwShellLeftNavButtonIcon":"CwShellLeftNavButton-cwShellLeftNavButtonIcon","cwShellLeftNavButton":"CwShellLeftNavButton-cwShellLeftNavButton","fat":"CwShellLeftNavButton-fat","active":"CwShellLeftNavButton-active","default":"CwShellLeftNavButton-default","cwShellLeftNavButtonLabel":"CwShellLeftNavButton-cwShellLeftNavButtonLabel","cwShellLeftNavLinkContainer":"CwShellLeftNavButton-cwShellLeftNavLinkContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshellleftnav/cwshellleftnavbutton/CwShellLeftNavButton.scss
// module id = 387
// module chunks = 0